import _                         from 'underscore';
import React, { FC }                         from 'react';
import { ItemFromQuery, ItemFromQueryProps } from '../from-query/ItemFromQuery';
import { DecisionEngineQueries }             from '../../../queries';

interface HireTypeItemProps {
    id: string,
    attributes?: string,

    as?: ItemFromQueryProps['as']
}


const defaultProps: HireTypeItemProps = {
    id:         null,
    attributes: DecisionEngineQueries.fragments.HIRE_TYPE.QUERY_RETURN(),
}

const HireTypeItem: FC<HireTypeItemProps> = ( props ) => {

    if( !props.id ) return null;

    return (
            <ItemFromQuery
                    as={props.as}
                    query={ DecisionEngineQueries.queries.GET_HIRE_TYPE( props.attributes ) }
                    queryOptions={ { variables: { id: props.id } } }
                    queryResultObject={ ( data: any ) => data.hireTypes[0] }>

                { ( item: any ) => _.isFunction( props.children ) ? props.children( item ) : props.children }

            </ItemFromQuery>
    );
};

HireTypeItem.defaultProps = defaultProps;

export { HireTypeItem }
